module.exports = __webpack_public_path__ + "img/wlcs-sdk.ea64275.png";